exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1iH-EP2Qr_9JNO8GC2Sav9{max-width:600px}._3sjIYi7xbq6zbu6DhD_8nQ{font-size:22px;font-weight:500}html[dir] ._2vaiKa_HsywaODZIQxZIt0{border:none}html[dir=ltr] ._1UWnUzS_jYDBjHkMmTX4O6,html[dir=ltr] .g3RGW3fTKN2fI-7y6AyjY{padding-left:25px}html[dir=rtl] ._1UWnUzS_jYDBjHkMmTX4O6,html[dir=rtl] .g3RGW3fTKN2fI-7y6AyjY{padding-right:25px}html[dir=ltr] ._1LqwIboYyzXN1dubnkci0o,html[dir=ltr] .h8h5RektEKf3spgWSY6PM{padding-left:25px}html[dir=rtl] ._1LqwIboYyzXN1dubnkci0o,html[dir=rtl] .h8h5RektEKf3spgWSY6PM{padding-right:25px}html[dir=ltr] ._9ghn4Y-uaxjgXRjeQG33u{text-align:right}html[dir=rtl] ._9ghn4Y-uaxjgXRjeQG33u{text-align:left}._1ItweYfKI2OGimvh00DjqY{font-style:italic;font-size:12px}", ""]);

// exports
exports.locals = {
	"recruitmentMain": "_1iH-EP2Qr_9JNO8GC2Sav9",
	"recruitmentHeader": "_3sjIYi7xbq6zbu6DhD_8nQ",
	"recruitmentTitle": "_2vaiKa_HsywaODZIQxZIt0",
	"ageRadioList": "_1UWnUzS_jYDBjHkMmTX4O6",
	"purposeRadioList": "g3RGW3fTKN2fI-7y6AyjY",
	"ageQuestion": "h8h5RektEKf3spgWSY6PM",
	"purposeQuestion": "_1LqwIboYyzXN1dubnkci0o",
	"messageButtonsDiv": "_9ghn4Y-uaxjgXRjeQG33u",
	"disclaimerDiv": "_1ItweYfKI2OGimvh00DjqY"
};